import React from "react";
import {
  TicketIconContainer,
  CustomTicketIconText,
} from "./TicketIcon.styles";
import OutlinedTicketIcon from '../../../public/images/logo-ticket-outlined.svg';
import DottedTicketIcon from "../../../public/images/logo-ticket-outlined-dotted.svg";
import SolidGrayTicketIcon from "../../../public/images/logo-ticket-solid-gray.svg";
import SolidBlueTicketIcon from "../../../public/images/logo-ticket-solid-blue.svg";
import SolidBlueTicketIconWithArrow from "../../../public/images/logo-ticket-solid-blue-with-arrow.svg";
import SolidGreenTicketIcon from "../../../public/images/logo-ticket-solid-green.svg";
import SolidRedTicketIcon from "../../../public/images/logo-ticket-solid-red.svg";
import GoldOutlinedTicketIcon from "../../../public/images/logo-ticket-gold-outlined.svg";
export interface CustomVariantTicketIconProps {
  ticketIconStyle?: "dotted" | "outlined" | "solid-gray" | "solid-blue-with-arrow" | "solid-blue" | "solid-green" | "solid-red" | "gold-outlined";
  ticketNumber?: number | null;
}

export const TicketIcon = ({
  ticketIconStyle = "outlined",
  ticketNumber = null,
  ...rest
}: CustomVariantTicketIconProps) => {

  const ticketIconStyleSwitch = () => {
    switch(ticketIconStyle) {
      case 'dotted':
        return <DottedTicketIcon/>;
      case 'solid-gray':
        return <SolidGrayTicketIcon/>;
      case 'solid-blue':
        return <SolidBlueTicketIcon/>;
      case 'solid-green':
        return <SolidGreenTicketIcon/>;
      case 'solid-red':
        return <SolidRedTicketIcon/>;
      case 'gold-outlined':
        return <GoldOutlinedTicketIcon/>;
      case 'solid-blue-with-arrow':
        return <SolidBlueTicketIconWithArrow/>;
      default:
        return <OutlinedTicketIcon/>;
    }
  }

  return (
    <TicketIconContainer>
      {ticketIconStyleSwitch()}
      <CustomTicketIconText>
        {ticketNumber}
      </CustomTicketIconText>
    </TicketIconContainer>
  );
};

export interface TicketIconProps extends React.ComponentProps<typeof TicketIcon> {
  as?: React.ElementType;
}

TicketIcon.displayName = "TicketIcon";